import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=b35db646&scoped=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=b35db646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35db646",
  null
  
)

export default component.exports